/* eslint-disable no-undef */
import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
    },
    getters: {
       
    },
    mutations: {
       
    },
    actions: {
        async getMonitorList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manager.monitorIndex, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        }, 

       
        async getOpObject({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manager.apIndex, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async addOpObject({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.apAdd, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        }, 
        async delOpObject({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.apDel, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        }, 
        async getNotifyPerList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manager.notiPersonList, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async addNotifyPerson({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.notiPersonAdd, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async updateNotifyPerson({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.notiPersonUpdate, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        }, 
        async delNotifyPerson({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.notiPersonDel, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },  
        async closeNotifyPerson({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.notiPersonClose, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },   
        async getMonitorIndex({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.mindex, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getMonitorChart({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.mchart, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getNotiMsgList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manager.msgList, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getNotiMsgDetail({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manager.msgDetail, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async readNotiMsg({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.msgRead, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async downLoadData({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.downLoad, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async annualFeeInfo({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manager.feeInfo, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async addMonitorPatent({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.addMonitor, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getErcodeImg({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manager.ercode, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async downLoadFeedata({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.feeExport, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async monitorPatentDel({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.manager.delPatent, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        //服务器端轮询年费
        async getFeeInfoParam({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.fee.feeInfoParam, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getInfo ({commit}, {data, handle}) {
            try {
              const rsp = await axios.post(ApiUrl.fee.info, data.param, data.head)
              handle && handle(rsp.data)
            } catch (e) {
              console.error(e)
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
    }
}